<template>
  <section class="timeline-column" id="timeline-column">
    <div v-for="(item, index) in items" :key="index" class="column-card">
      <h1>{{ item.date }}</h1>
      <h2>{{ item.title }}</h2>
      <p v-html="item.text"></p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TimelineColumn',
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.timeline-column {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.column-card {
  border: 2px solid #00f0ff;
  color: #ffffff;
  background-color: #323336;
  border-radius: 30px;
  padding: 1rem;
}

.column-card > * {
  margin: 0;
}

.column-card > p {
  margin-top: 10px;
  line-height: 1.1;
}
</style>
